import styled, { css } from 'styled-components'

import { ColorGradients } from 'common-constants/colors'
import { media } from 'components/presentational'
import { zIndex } from 'components/presentational/zIndex'

export const Wrapper = styled.div`
  display: grid;
  grid-template:
    'Head Head' 45px
    '. .' 1fr
    'Footer Footer' auto
    / minmax(300px, 1fr) minmax(200px, 450px);
  grid-gap: 0 30px;
  gap: 0 30px;

  ${media.tablet`
    display: block
  `}
`

export const WrapperPhoto = styled.div`
  position: relative;

  &::before {
    display: none;
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 246px;
    background-image: ${ColorGradients.transparentToDarkBlueGray};
    z-index: 1;
    border-radius: 0 0 10px 10px;
  }

  ${media.tablet`   
    &::before {
      display: block;
    }    
  `}
`

export const InteractiveMobileBlock = styled.div`
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 2;

  ${media.tablet`
    display: block;
  `}
`

export const InteractiveDesktopBlock = styled.div`
  ${media.tablet`
    display: none;
  `}
`

export const Header = styled.header`
  grid-area: Head;
`

export const WrapperGreeting = styled.div`
  padding: 20px 0;
  margin: 20px 0 -20px;
  overflow-wrap: anywhere;

  ${media.tablet`
    margin: 0 10px -20px 10px;
  `}
`

interface StickyWrapperProps {
  $hide: boolean
}

export const StickyWrapper = styled.div<StickyWrapperProps>`
  display: none;
  position: sticky;
  bottom: 10px;
  transform: translateY(${(props) => (props.$hide ? '100px' : '0px')});
  transition: transform 0.3s ease;
  height: 72px;
  overflow: hidden;
  z-index: ${zIndex.overAdvertising};

  ${media.tablet`
     display: block;
  `}
`

export const WrapperGroup = styled.div`
  margin: 30px 0;

  ${media.tablet`
    margin: 20px 10px;
  `}
`

export const WrapperDesktop = styled.div`
  display: block;

  ${media.tablet`
    display: none;
  `}
`

export const WrapperMobileCss = css`
  display: none;

  ${media.tablet`
    display: block;
  `}
`

export const WrapperMobile = styled.div`
  ${WrapperMobileCss}
`

export const MarginSearchBottom = styled.div`
  grid-area: Footer;
  margin-top: 60px;

  ${media.phone`
    margin-top: 40px;
  `}
`
